<template>
  <div class="attachments">
    <span class="label" :style="labelStyle"><em v-if="required">* </em>{{labelText}}:</span>
    <div class="attachmentsContent">
      <el-upload
        :disabled = 'disabled'
        class="avatar-uploader"
        :action="attachmentsUploadUrl"
        :show-file-list="false"
        :on-success="cropUploadSuccess"
        :data="{type: typeNum}"
        accept=".mp4,.MOV,.wmv,.avi,.mpg,.mpeg,.rm,.ram"
        :headers="myHeaders"
        :before-upload="beforeUploadVideo"
        :on-progress="handleProgress"
      >

        <video v-if="value" width="300" :src="imageUrl" controls ref="videoPlayer" @loadeddata="onVideoLoaded">
          Your browser does not support the video tag.
        </video>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div v-if="progressVisible" class="progress-container">
        <el-progress :percentage="uploadPercentage"></el-progress>
      </div>
      <span class="text">{{text}}</span>
      <br/>
      <el-button type="text"  @click="deleteVideo">删除视频</el-button>
    </div>
  </div>
</template>

<script>
  import Cookies from "js-cookie";

  export default {
    name: "videoUpload",
    props: {
      required: {
        type: Boolean,
        default: false
      },
      label: String,
      value: '',
      labelWidth: String,
      width: Number,
      height: Number,
      type: Number,
      text: String,
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      const domain = window.location.origin;
      return {
        myHeaders: {token: Cookies.get('token')},
        imageUrl: this.value,
        showBigImage: false,
        // attachmentsUploadUrl: "/pubServer/upload/upload",
        attachmentsUploadUrl: "/public-service/upload/upload",
        labelText: this.label || '视频上传',
        typeNum: this.type || 1,
        uploadPercentage: 0,
        progressVisible: false
      }
    },
    methods: {
      cropUploadSuccess(jsonData, field) {
        this.progressVisible = false;
        this.updateVideo()
        this.imageUrl = jsonData.data.result.imageUrl;
        this.$emit('input', this.imageUrl)
      },
      updateVideo() {
        const videoElement = this.$refs.videoPlayer;
        if (videoElement) {
          videoElement.pause(); // 暂停视频
          // 可以在这里再次调用 videoElement.play(); 来播放新视频（如果需要）
        }
      },
      onVideoLoaded() {
        console.log('Video loaded', this.imageUrl);
      },
      deleteVideo() {
        this.imageUrl = ''
        this.$emit('input', '')
      },
      beforeUploadVideo(file) {
        // 限制视频大小（这里限制为100MB）
        const isLt100M = file.size / 1024 / 1024 < 100;

        if (!isLt100M) {
          this.$message.error('上传视频大小不能超过100MB!');
          return false; // 返回false会阻止上传
        }
        this.progressVisible = true;
        this.uploadPercentage = 0;
        return true; // 返回true允许上传
      },
      handleProgress(event, file, fileList) {
        // 计算上传进度
        this.uploadPercentage = Math.floor(event.percent);
      },

      handleError(err, file, fileList) {
        this.progressVisible = false;
        this.$message.error('视频上传失败!');
      }
    },
    computed: {
      labelStyle() {
        const w = this.labelWidth || '100';
        return {
          width: w + 'px'
        }
      }
    },
    watch: {
      value: function(val, oldVal) {
        this.imageUrl = val
      }
    },
  }
</script>

<style scoped lang="sass">
  .attachments
    display: flex
    margin-bottom: 20px
    .label
      text-align: right
      vertical-align: middle
      float: left
      font-size: 14px
      color: #606266
      line-height: 36px
      padding: 0 12px 0 0
      -webkit-box-sizing: border-box
      box-sizing: border-box
      flex-shrink: 0
      em
        font-style: normal
        color: #f56c6c
    .input-box
      font-size: 12px
      color: #606266
      span
        margin-left: 5px
    .attachmentsContent
      width: 100%
      .upload-image
        width: 150px
      .text
        font-size: 12px
        line-height: 26px
        color: #606266

  .avatar-uploader .el-upload
    border: 1px dashed #d9d9d9
    border-radius: 6px
    cursor: pointer
    position: relative
    overflow: hidden

  .avatar-uploader .el-upload:hover
    border-color: #409EFF

  .avatar-uploader-icon
    font-size: 20px
    color: #8c939d
    width: 150px
    height: 150px
    line-height: 150px
    text-align: center
    border: 1px dashed #ccc
    background: #fff

  .avatar
    width: 150px
    display: block

  .progress-container
    margin-top: 10px
    width: 100%
    display: flex
    align-items: center


  .progress-container .el-progress
    flex-grow: 1
    margin-right: 10px

</style>



// WEBPACK FOOTER //
// src/opr/components/videoUpload.vue